import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { PlatformEnum } from '@panamax/app-state';
import { ExceptionResolution, OrderItem } from '@usf/ngrx-order';
import { ImageVariantEnum } from 'src/app/product-detail/models/image-variant.enum';
import { getFirstImageURL } from 'src/app/product-detail/utils/product-images.util';
import { QuantityInputComponent } from 'src/app/shared/components/quantity-input/quantity-input.component';
import { Product } from 'src/app/shared/models/product.model';
import { ResolutionType } from '../../../../pages/order-exceptions/constants/resolution-type.enum';
import { EmittedResolution } from '../../../../pages/order-exceptions/models/emitted-resolution.model';
import { ProductSummary } from '@usf/product-types';
import { getAlternativeThumbnail } from 'src/app/product-detail/utils/product-images.util';
import { ExceptionType } from '../../../../pages/order-exceptions/constants/order-exception-type.enum';

@Component({
  template: '',
})
export class FlipsideProductBaseComponent implements OnInit, OnChanges {
  @Input() productState: ProductSummary;
  @Input() isOffline: boolean;
  @Input() exceptionResolution: ExceptionResolution;
  @Input() product: Product;
  @Input() subOrderItem: OrderItem;
  @Input() isPackSizeDifferent: boolean;
  @Input() originalProduct: Product;
  @Input() units: number;
  @Input() eaches: number;
  @Input() platformEnum: PlatformEnum;
  @Input() exceptionType: ExceptionType;
  @ViewChild('unitsOrderedInput')
  unitsOrderedInput: QuantityInputComponent;
  @ViewChild('eachesOrderedInput')
  eachesOrderedInput: QuantityInputComponent;
  @Output() exceptionResolved = new EventEmitter();
  @Output() backButtonClicked = new EventEmitter();
  thumbnailImageURL: string;
  quantityChanged = false;
  exceptionTypes = ExceptionType;
  subOrReplaceItem: OrderItem;

  constructor() {}

  ngOnInit(): void {
    this.thumbnailImageURL = getFirstImageURL(
      this.product?.summary,
      ImageVariantEnum.Medium,
    );
    this.subOrReplaceItem =
      this.exceptionResolution?.orderException?.subOrReplaceItems?.find(
        item => item.productNumber === this.product?.summary?.productNumber,
      );
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.productState?.currentValue) {
      this.thumbnailImageURL = getFirstImageURL(
        this.product?.summary,
        ImageVariantEnum.Medium,
      );
    }
    this.subOrReplaceItem =
      this.exceptionResolution?.orderException?.subOrReplaceItems?.find(
        item => item.productNumber === this.product?.summary?.productNumber,
      );
  }

  getAternativeThumbnail = (thumbnailImageURL: string): string =>
    getAlternativeThumbnail(this.productState, thumbnailImageURL);

  onExceptionResolution() {
    const copySubOrderItem: OrderItem = JSON.parse(
      JSON.stringify(this.subOrderItem),
    );
    copySubOrderItem.unitsOrdered.previousValue = Number(
      this.unitsOrderedInput?.itemInputBox.value,
    );
    copySubOrderItem.unitsOrdered.currentValue = Number(
      this.unitsOrderedInput?.itemInputBox.value,
    );

    copySubOrderItem.eachesOrdered.previousValue = Number(
      this.eachesOrderedInput?.itemInputBox.value,
    );
    copySubOrderItem.eachesOrdered.currentValue = Number(
      this.eachesOrderedInput?.itemInputBox.value,
    );

    const resolution: EmittedResolution = {
      exceptionResolution: { ...this.exceptionResolution, expanded: false },
      resolutionType: ResolutionType.SUBSTITUTE,
      subOrderItem: copySubOrderItem,
    };
    this.exceptionResolved.emit(resolution);
  }

  goBack() {
    this.backButtonClicked.emit();
  }

  changeQuantityHandler(quantityUpdate: any) {
    if (
      (quantityUpdate?.isEaches &&
        quantityUpdate?.quantity !==
          this.exceptionResolution?.resolutionOrderItem?.substituteProduct
            ?.eachesOrdered?.currentValue) ||
      (!quantityUpdate?.isEaches &&
        quantityUpdate?.quantity !==
          this.exceptionResolution?.resolutionOrderItem?.substituteProduct
            ?.unitsOrdered?.currentValue)
    ) {
      this.quantityChanged = true;
    }

    if (quantityUpdate?.isEaches && this.eachesOrderedInput?.quantity) {
      this.eachesOrderedInput.quantity = {
        ...this.eachesOrderedInput.quantity,
        previousValue: this.eachesOrderedInput.quantity.currentValue,
        currentValue: quantityUpdate.quantity,
      };
    } else if (this.unitsOrderedInput?.quantity) {
      this.unitsOrderedInput.quantity = {
        ...this.unitsOrderedInput.quantity,
        previousValue: this.unitsOrderedInput.quantity.currentValue,
        currentValue: quantityUpdate.quantity,
      };
    }
  }
}
